import { useContainerProps, usePropsVideoBehaviorList } from './hooks';
import TtamBehaviorVideoActions from './behavior-video-actions/index.vue';
import TtamBehaviorVideoCategory from './behavior-video-category/index.vue';
import TtamBehaviorVideoDay from './behavior-video-day/index.vue';

export default {
  TtamBehaviorVideoActions,
  TtamBehaviorVideoCategory,
  TtamBehaviorVideoDay,
  useContainerProps,
  usePropsVideoBehaviorList,
};
